<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.52,783.06L-2,784.51v0.05l-2.51-1.45l-2.51,1.45v2.9l0.03,0.02l-2.5,1.44v2.9l2.51,1.45l0.04-0.03v2.88l2.51,1.45v2.9
	l2.51,1.45l2.47-1.43l2.47,1.43l2.51-1.45v-2.9l0,0l2.51-1.45v-2.9l-0.03-0.02l2.47-1.43v-2.9l-2.51-1.45l0,0v-2.9l-2.51-1.45
	l-2.48,1.43L0.52,783.06z M-5.06,791.34c0.03,0.2,0.08,0.34,0.16,0.44c0.15,0.18,0.4,0.27,0.75,0.27c0.21,0,0.39-0.02,0.52-0.07
	c0.25-0.09,0.38-0.26,0.38-0.5c0-0.14-0.06-0.25-0.19-0.33c-0.13-0.08-0.32-0.14-0.59-0.2l-0.46-0.1c-0.45-0.1-0.76-0.21-0.93-0.33
	c-0.29-0.2-0.44-0.51-0.44-0.93c0-0.39,0.14-0.71,0.42-0.96s0.69-0.38,1.24-0.38c0.46,0,0.84,0.12,1.16,0.36s0.49,0.59,0.51,1.05
	h-0.87c-0.02-0.26-0.13-0.44-0.34-0.55c-0.14-0.07-0.32-0.11-0.52-0.11c-0.23,0-0.42,0.05-0.56,0.14c-0.14,0.09-0.21,0.22-0.21,0.39
	c0,0.15,0.07,0.27,0.21,0.35c0.09,0.05,0.28,0.11,0.56,0.18l0.74,0.18c0.33,0.08,0.57,0.18,0.74,0.31c0.26,0.2,0.39,0.5,0.39,0.88
	c0,0.39-0.15,0.72-0.45,0.98s-0.73,0.39-1.28,0.39c-0.56,0-1-0.13-1.33-0.38s-0.48-0.61-0.48-1.06H-5.06z M-1.78,788.36h0.9v4.32
	h-0.9V788.36z M-0.35,791.92l2.23-2.79h-2.17v-0.76h3.3v0.72l-2.26,2.83h2.26v0.76h-3.36V791.92z M6.82,789.12H4.53v0.92h2.1v0.75
	h-2.1v1.11h2.39v0.78H3.65v-4.32h3.17V789.12z M1.97,797.76H1.49v0.91H0.67v-0.91h-1.68v-0.73l1.56-2.58h0.94v2.66h0.48V797.76z
	 M0.67,797.11v-1.83l-1.06,1.83H0.67z"/>
</svg>

</template>